import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmLeaveDialogData {
  message: string;
  yesLabel: string;
  cancelLabel: string;
}

@Component({
    selector: 'app-survey-confirmation-dialog',
    templateUrl: './survey-confirmation-dialog.component.html',
    styleUrls: ['./survey-confirmation-dialog.component.scss']
})
export class SurveyConfirmationDialogComponent {

    constructor(
        private dialogRef: MatDialogRef<SurveyConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmLeaveDialogData
    ) { }

    onCancelClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.dialogRef.close(true);
    }
}
